import createIcon from '../../createIcon';

/**
 * @component @name Volcano
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggOC41SDExTDkgMTMuNUg2TDIgMjIuNUgyMkwxOCA4LjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTUgMS41SDEzVjUuNUgxNVYxLjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTguOTQ5NiAzLjEzOTg5TDE2LjEyMTIgNS45NjgyOUwxNy41MzU0IDcuMzgyNDlMMjAuMzYzOCA0LjU1NDA5TDE4Ljk0OTYgMy4xMzk4OVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik05LjA1Mzg5IDMuMTM2MUw3LjYzOTY5IDQuNTUwM0wxMC40NjgxIDcuMzc4N0wxMS44ODIzIDUuOTY0NUw5LjA1Mzg5IDMuMTM2MVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Volcano = createIcon('Volcano', [
  ['path', { d: 'M18 8.5H11L9 13.5H6L2 22.5H22L18 8.5Z', key: '1nvmt6' }],
  ['path', { d: 'M15 1.5H13V5.5H15V1.5Z', key: 'n9qaxr' }],
  [
    'path',
    {
      d: 'M18.9496 3.13989L16.1212 5.96829L17.5354 7.38249L20.3638 4.55409L18.9496 3.13989Z',
      key: 'eiphsq',
    },
  ],
  [
    'path',
    {
      d: 'M9.05389 3.1361L7.63969 4.5503L10.4681 7.3787L11.8823 5.9645L9.05389 3.1361Z',
      key: '18qscp',
    },
  ],
]);

export default Volcano;
